import { Resource } from '@/clients/utoniq-core/schema'

import { VideoDRMPlayer } from './VideoDRMPlayer'
import { VideoPurePlayer } from './VideoPurePlayer'

type Props = {
  resource: Resource
  open: boolean
  autoplay?: boolean
  onClose: () => void
}

export const VideoPlayer = ({ resource, autoplay, open, onClose }: Props) => {
  if (resource.drm?.encryptingStatus === 'encrypted') {
    return (
      <VideoDRMPlayer
        autoplay={autoplay}
        open={open}
        onClose={onClose}
        resource={resource}
      />
    )
  }

  return (
    <VideoPurePlayer
      autoplay={autoplay}
      open={open}
      onClose={onClose}
      uri={resource.uri}
    />
  )
}
